import { SearchOption } from "../types/SearchData";

export const getInputValue = (value: SearchOption | undefined, showSuffix = true) => {
	if (value === undefined || value === null) {
		return undefined;
	}

	if (typeof value === "string") {
		return value;
	}

	return showSuffix && value.suffix ? `${value.label} ${value.suffix}` : value.label;
};
